var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("EhrNavigation", { attrs: { "active-item": "photo" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container stack" },
        [
          _vm.moduleSettings.richtlijnen
            ? _c("div", { staticClass: "richtlijnen" }, [
                _vm._v(_vm._s(_vm.moduleSettings.richtlijnen))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "SectionCard",
            {
              attrs: {
                "card-icon": "image-portrait",
                "card-title": "Huidige foto"
              }
            },
            [
              _vm.currentPhoto
                ? _c("div", [
                    _c("img", {
                      staticClass: "photo-preview",
                      attrs: { src: _vm.currentPhoto.url, alt: "Huidige foto" }
                    })
                  ])
                : _c("p", { staticClass: "no-photo" }, [
                    _vm._v("\n                Geen foto\n            ")
                  ])
            ]
          ),
          _vm._v(" "),
          _c(
            "SectionCard",
            {
              attrs: {
                "card-icon": "image-portrait",
                "card-title": _vm.changeRequest
                  ? "Aanvraag in behandeling"
                  : "Nieuwe foto indienen"
              }
            },
            [
              _vm.changeRequest
                ? _c("div", { staticClass: "change-request" }, [
                    _c("div", [
                      _c("img", {
                        staticClass: "photo-preview",
                        attrs: {
                          src: _vm.changeRequest.url,
                          alt: "Huidige foto"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stack" }, [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: { type: "button" },
                            on: { click: _vm.onCancelChangeRequest }
                          },
                          [_vm._v("Aanvraag annuleren")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "edit-change-request" },
                        [
                          _c("PhotoChangeRequestForm", {
                            attrs: {
                              fileUploadLabel: "Aangevraagde foto wijzigen",
                              submitLabel: "Gewijzigde aanvraag indienen"
                            },
                            on: { upload: _vm.onUpload }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _c(
                    "div",
                    [
                      _c("PhotoChangeRequestForm", {
                        attrs: {
                          fileUploadLabel: "Nieuwe foto",
                          submitLabel: "Aanvraag indienen"
                        },
                        on: { upload: _vm.onUpload }
                      })
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }